import React from "react";
import { post } from "../fetchData";

const useFetchPage = ({ slug, endpoint }:{ slug: string, endpoint: string }) => {
  const [data, setPage] = React.useState<any>({});
  const [loading, setLoading] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    listPage();
  }, []);

  const listPage = () => {
    setLoading(true);
    setLoaded(false);
 post( { slug:slug},endpoint).then(
        (result) => {
          setLoading(false);
          console.log(result);
            setPage(result?.status ? result : {});
        },
        (error) => {
          setPage({});
        }
      )
      .finally(() => {
        setLoading(false);
        setLoaded(false);
      }); //fetch
  }; //doAjax

  return {data,loading,loaded};
};

export default useFetchPage;
